import { Component } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BannerService } from 'src/app/services/banner/banner.service';
import { LanguageService } from 'src/app/services/language/language.service';
import { BannerModalComponent } from './banner-modal/banner-modal.component';
import { AdminService } from 'src/app/services/admin/admin.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CdkDragDrop, DragDropModule, moveItemInArray } from '@angular/cdk/drag-drop';
import { SpinnerComponent } from "../../layout/spinner/spinner.component";

export interface BannerItem {
  id: number;
  lang: string;

  title: string;
  url: string;

  target: number | string; // 0/1 ან '_self'/'_blank'

  // optional (შენ გინდა null იყოს)
  src?: string | null;     // DB column: src
  width?: number | null;
  height?: number | null;

  visible?: number;        // 0/1
  sort?: number;
  pos?: number;
  place?: string | null;
}


@Component({
  selector: 'app-banner',
  imports: [CommonModule, FormsModule, DragDropModule, SpinnerComponent],
  templateUrl: './banner.component.html',
  styleUrl: './banner.component.css'
})

export class BannerComponent {
  loading = false;

  items: BannerItem[] = [];

  search = '';
  visible: 'all' | '1' | '0' = 'all';

  lang = 'geo';

  // sort mode (drag-drop თუ გინდა შემდეგ ეტაპზე დავამატებთ)
  isSorting = false;

  togglingId: number | null = null;

  constructor(
    private bannerService: BannerService,
    private langService: LanguageService,
    private modal: NgbModal,
    public admin: AdminService
  ) {
    this.lang = this.langService.getLanguage();
    this.langService.currentLanguage$.subscribe((l) => {
      this.lang = l;
      this.get();
    });
  }


  togglingIds = new Set<number>();
  deletingIds = new Set<number>();

  isToggling(id: number): boolean {
    return this.togglingIds.has(id);
  }

  isDeleting(id: number): boolean {
    return this.deletingIds.has(id);
  }


  get() {
    this.loading = true;
    this.bannerService
      .list({ lang: this.lang, search: this.search, visible: this.visible })
      .subscribe({
        next: (res) => {
          this.items = res?.data ?? [];
          this.loading = false;
        },
        error: () => (this.loading = false),
      });
  }

  openCreate() {
    const ref = this.modal.open(BannerModalComponent, { size: 'lg', backdrop: 'static' });
    ref.componentInstance.lang = this.lang;
    ref.componentInstance.itemId = null;
    ref.closed.subscribe((ok) => {
      if (ok) this.get();
    });
  }

  openEdit(id: number) {
    const ref = this.modal.open(BannerModalComponent, { size: 'lg', backdrop: 'static' });
    ref.componentInstance.lang = this.lang;
    ref.componentInstance.itemId = id;
    ref.closed.subscribe((ok) => {
      if (ok) this.get();
    });
  }



  toggleVisible(item: BannerItem) {
    if (this.togglingId === item.id) return;

    this.togglingId = item.id;

    this.bannerService.toggleVisible(item.id, this.lang).subscribe({
      next: (res) => {
        item.visible = res.visible;
        this.togglingId = null;
      },
      error: () => {
        this.togglingId = null;
      }
    });
  }

  delete(item: BannerItem) {
    if (!confirm('წავშალო?')) return;

    this.deletingIds.add(item.id);

    this.bannerService.delete(item.id, this.lang).subscribe({
      next: () => this.get(),
      error: () => this.deletingIds.delete(item.id),
      complete: () => this.deletingIds.delete(item.id),
    });
  }

  drop(event: CdkDragDrop<BannerItem[]>) {
    if (!event || event.previousIndex === event.currentIndex) return;

    // Update UI order
    moveItemInArray(this.items, event.previousIndex, event.currentIndex);

    // Persist order to backend
    this.saveSortOrder();
  }

  // თუ sort endpoint გაქვს მზად:
  saveSortOrder() {
    const ids = this.items.map((x) => x.id);
    this.bannerService.sort(this.lang, ids).subscribe({
      next: () => (this.isSorting = false),
      error: () => {},
    });
  }

  ngOnInit() {
    this.get();
  }
}
